import { numberFunctions } from "./common/constants/functions/numberFunctions";
import { checkTopComponent, setAttributesPopUp } from "./components/ads";
import { loadEventFooter } from "./components/footer-menu";
import { handleNavbar } from "./components/navbar";
import { loadSliders } from "./components/sliders";
import { Search } from "./components/search";
import { loadScript, nameForm } from "./components/script";
import { scrollRight } from "./partials/scrollNav";
// Creating instances of the necessary classes
const search = new Search();
// Exposing methods to the global window object for external usage
// Search
window.setInputId = search.setInputId;
window.search_txt = search.search_txt;
window.search_onInput = search.search_onInput;
window.search_onKeyDown = search.search_onKeyDown;
window.changeTipo = search.changeTipo;
window.scrollRight = scrollRight;
window.nameForm = nameForm;
// Load Footer
loadEventFooter();
// Load Navbar
handleNavbar();
// Load Script.ts
loadScript();
// Load global functions
window.blockLetters = numberFunctions.blockLetters;
window.blockNumbers = numberFunctions.blockNumbers;
window.formatInputCurrency = numberFunctions.formatInputCurrency;
window.addThousandsSeparator = numberFunctions.addThousandsSeparator;
// Load Ads
window.checkTopComponent = checkTopComponent;
checkTopComponent();
setAttributesPopUp();
document.addEventListener('DOMContentLoaded', () => {
    // load Slider
    setTimeout(() => {
        loadSliders();
    }, 500);
});
